import { createContext, useContext, useState, useEffect } from "react";
import CryptoJS from "crypto-js";

const UserContext = createContext();

export const useUserContext = () => {
  return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const GET_USER = `${SERVER_URI}/user`;

  const [user, setUser] = useState(null);
  const [secretKey, setSecretKey] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem("accessToken");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      try {
        // Fetch user data from the API
        const response = await fetch(GET_USER, {
          withCredential:true
        });
        const userData = await response.json();

        // Calculate the 16-bit secret key (parsed as a hex string)
        const email = userData.email || "";

        // Convert string to array of bytes
        const byteArray = new TextEncoder().encode(email.slice(0, 16));

        // Convert array of bytes to hex string
        let calculatedKey = Array.from(byteArray)
          .map((byte) => byte.toString(16).padStart(2, "0"))
          .join("");

        calculatedKey = calculatedKey.padEnd(16, "0");

        // Hash the calculated key using SHA256 (you can choose a different algorithm)
        const hashedKey = CryptoJS.SHA256(calculatedKey).toString();

        // Set the user and secret key in the context
        setUser(userData);
        setSecretKey(hashedKey);

        // Log the hashed key
      
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []); // Empty dependency array ensures the effect runs only once on component mount

  const logout = () => {
    // Clear user and secret key on logout
    setUser(null);
    setSecretKey(null);
  };

  return (
    <UserContext.Provider value={{ user, secretKey, logout }}>
      {children}
    </UserContext.Provider>
  );
};
